export function FilterChips({ categories, selected, onSelect }) {
  return (
    <div className="hide-scrollbar -mx-4 flex gap-2 overflow-x-auto px-4 py-2 sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
      <button
        onClick={() => onSelect(null)}
        className={`shrink-0 rounded-full border px-4 py-2 text-sm font-medium transition-all ${
          selected === null
            ? 'border-brand-gold bg-brand-gold/10 text-brand-navy'
            : 'border-brand-slate/20 bg-white text-brand-slate hover:border-brand-gold hover:text-brand-navy'
        }`}
      >
        All
      </button>
      {categories.map((cat) => (
        <button
          key={cat.id}
          onClick={() => onSelect(cat.name)}
          className={`shrink-0 rounded-full border px-4 py-2 text-sm font-medium transition-all ${
            selected === cat.name
              ? 'border-brand-gold bg-brand-gold/10 text-brand-navy'
              : 'border-brand-slate/20 bg-white text-brand-slate hover:border-brand-gold hover:text-brand-navy'
          }`}
        >
          {cat.name}
        </button>
      ))}
    </div>
  )
}
